module.exports = __webpack_public_path__ + "img/screenshot-4.93c93390.png";